import { types } from 'mobx-state-tree';
import { countOccurrences } from '@wemogy/reactbase';
import AzureStorageEntryKind from '../enums/AzureStorageEntryKind';
var splitCharacter = '/';
var resolveHierarchyLevel = function (path) {
    return countOccurrences(path, splitCharacter);
};
var AzureStorageEntry = types.model({
    kind: AzureStorageEntryKind,
    fullName: types.string,
    uri: types.string,
    level: types.optional(types.number, 0)
})
    .named('AzureStorageEntry')
    .views(function (self) { return ({
    get isBlob() {
        return self.kind === 'blob';
    },
    get name() {
        return self.fullName.split(splitCharacter).pop() || '';
    },
    get prefix() {
        return self.fullName + "/";
    },
    isDirectChildOf: function (prefix) {
        var prefixLevel = resolveHierarchyLevel(prefix);
        return prefixLevel === self.level && self.fullName.startsWith(prefix);
    },
    isSame: function (other) {
        return self.fullName === other.fullName && self.kind === other.kind;
    }
}); })
    .actions(function (self) { return ({
    afterCreate: function () {
        // prefix ends with /, for that reason we remove that
        if (self.fullName.endsWith('/')) {
            self.fullName = self.fullName.slice(0, -1);
        }
        self.level = resolveHierarchyLevel(self.fullName);
    }
}); });
export default AzureStorageEntry;
//# sourceMappingURL=AzureStorageEntry.js.map